import { LightbulbIcon, MoreHorizontalIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';

/**
 * Props for the AnswerExplanationSection component.
 * @property explanation - Explanation text to display.
 * @property onOpenExplanation - Callback to open the explanation dialog.
 */
interface ExplanationSectionProps {
  explanation?: string;
  onOpenExplanation: () => void;
}

export function AnswerExplanationSection(explanationSectionProps: ExplanationSectionProps) {
  const { explanation, onOpenExplanation } = explanationSectionProps;

  if (explanation) {
    return (
      <div className="text-muted-foreground bg-accent flex items-center gap-2 rounded-md p-2 text-sm">
        <p className="line-clamp-4 grow overflow-hidden">{explanation}</p>
        <Button type="button" size={'sm'} variant={'ghost'} className={'h-7 min-h-7 w-7 min-w-7'} onClick={onOpenExplanation} aria-label={'Edytuj wyjaśnienie'}>
          <MoreHorizontalIcon />
        </Button>
      </div>
    );
  }

  return (
    <Button type="button" size={'sm'} variant={'outline'} className={'w-full border-dashed'} onClick={onOpenExplanation}>
      <LightbulbIcon />
      Wyjaśnienie
    </Button>
  );
}
